/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 오늘의 홍보학교 더보기 페이지
 * 버전 : 1.0
 * 파일명 : TodaysPromoPage.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-07-02
 * 수정 : 2025-07-03, 강동형 : 탭 요소를 컴포넌트로 분할
 * ================================================================ */

import { useState } from 'react';
import { Icon_Inform } from 'src/components/common/CommonIcons';
import SchoolListSheet from 'src/components/main/SchoolListSheet';
import PromotionEffect from 'src/components/todaysPromotion/PromotionEffect';
import PromotionRecommand from 'src/components/todaysPromotion/PromotionRecommand';
import styled from 'styled-components'

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
const TabWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items:center;
  gap: 20px;

  width:'100%';
  border-bottom: 1px solid #DDDDDD;
  padding-left: 20px;
`

interface TabContainerProps {
  tab: boolean;
}
const TabContainer = styled.button<TabContainerProps>`
  all: unset;
  color: '#000014';
  opacity: ${({ tab }) =>tab ? 1 : 0.5};
  font-size: 16px;
  font-weight: ${({ tab }) =>tab ? 700 : 500};
  border-bottom: ${({ tab }) =>tab ? '2px solid #000000' : '2px solid transparent'};
  padding : 15px 0px;
`;

const InformWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;

  width: calc(100% - 20px);
  margin: 10px;
  padding: 10px;
  color: #000;
  font-size: 14px;
  font-weight: 500;
  background-color: #F5F5F5;
  box-sizing: border-box;
`

type TodaysPromoTabType = '공고 맞춤 추천' | '홍보효과'

const TodaysPromoPage = () => {
  const [tab,setTab] = useState<TodaysPromoTabType>('공고 맞춤 추천')
  return (
    <PageWrapper>
      <TabWrapper>
        <TabContainer tab={tab === '공고 맞춤 추천'} onClick={()=>setTab('공고 맞춤 추천')}>공고 맞춤 추천</TabContainer>
        <TabContainer tab={tab === '홍보효과'} onClick={()=>setTab('홍보효과')}>홍보효과</TabContainer>
      </TabWrapper>
      <InformWrapper>
        <Icon_Inform/>
        <div>
        {tab === '공고 맞춤 추천' &&
            'AI가 모집 공고의 정보를 분석하여 해당 공고에 적합한 홍보 학교를 추천합니다.'
        }
        {tab === '홍보효과' &&
            '과거 홍보기록 데이터를 AI로 분석하여 홍보 효과가 좋을 것으로 예측되는 학교를 추천합니다.'
        }
        </div>
      </InformWrapper>
      {tab === '공고 맞춤 추천' && <PromotionRecommand/>}
      {tab === '홍보효과' && <PromotionEffect/>}
      <SchoolListSheet/>
    </PageWrapper>
  )
}

export default TodaysPromoPage